import { units } from '@ui/css';
import { makeSelectors, combineTokens, makeScaleableToken } from '@utils/css';

const scrollbarSelectors = makeSelectors({
  visible: "visible-scrollbars"
});
const scrollbarTokens = combineTokens("--scrollbar", {
  width: [units.px(0), makeScaleableToken]
});

export { scrollbarSelectors, scrollbarTokens };
//# sourceMappingURL=scrollbar-properties.selectors.js.map
